export const ProductItemType = {
    Default: 'default',
    Alternative: 'alternative',
};
